import axios from 'axios';
import { getToken , setToken} from "./auth";

import { config } from './constants'

const url = config.url.NEST_URL

const nest = axios.create({
  baseURL: url
});
nest.interceptors.request.use(async config => {
  const token = getToken();
  if (token) {
    config.headers.Authorization = "bearer " + token;
  }
  return config;
});
nest.interceptors.response.use((response) => {
  // Do something with response data
  return response;
},(error) => {
  // Do something with response error
  
  // You can even test for a response code 
  // and try a new request before rejecting the promise
  if (error.response === undefined) {  
    return error;
  }
  if (error.response.status === 401) {     
    setToken(null);
    return window.location.href = '/'
  }
  if (error.response.status === 403) {     
    setToken(null);
    return window.location.href = '/'
  }
  return Promise.reject(error);
});

export default nest;